export default __webpack_public_path__ + "0616041a1eedb3322f3c88d32d3cb3c1.png";